let isPortuguese = false
let isAbroad = false

const translateWhenFromAbroad = async () => {
  const localization = window.shopifyLocalization
  const countryCode = window.shopifyLocalization?.countryCode
  if (countryCode !== 'AR') isAbroad = true
  else if (countryCode === 'BR' || countryCode === 'PT') isPortuguese = true
  generateCalculator(true)
};

const generateCalculator = (portuguese = false) => {
    const calculatorDiv = portuguese ? `<div class="m-bottom-half display-when-content-ready clear-both" id="calculadora-m2">
    <div class="row-fluid">
        <div class="contenedor">
            <h4><strong>Calculadora</strong></h4>
            <p>Insira a altura e a largura da superfície a ser coberta. Lembre-se de que 1 unidade de produto equivale a 1 metro quadrado.</p>
            <div class="conjunto">
                <label>Altura (m)</label>
                <input type="number" min="0" max="99" step=".01" name="alto" placeholder="Ex: 3.20" />
            </div>
            <div class="conjunto">
                <label>Largura (m)</label>
                <input type="number" min="0" max="99" step=".01" name="ancho" placeholder="Ex: 2" />
            </div>  
            <a class="calcule" href="#">Calcular</a>
            <p class="resultado"></p>
        </div>
    </div>
</div>`
//         : isAbroad ? `<div class="m-bottom-half display-when-content-ready clear-both" id="calculadora-m2">
// <div class="row-fluid">
// <div class="contenedor">
//     <h4><strong>Calculator</strong></h4>
//     <p>Enter the height and width of the surface to be covered. Remember that 1 unit of the product equals 1 square meter.</p>
//     <div class="conjunto">
//         <label>Height (m)</label>
//         <input type="number" min="0" max="99" step=".01" name="alto" placeholder="E.g., 3.20" />
//     </div>
//     <div class="conjunto">
//         <label>Width (m)</label>
//         <input type="number" min="0" max="99" step=".01" name="ancho" placeholder="E.g., 2" />
//     </div>  
//     <a class="calcule" href="#">Calculate</a>
//     <p class="resultado notranslate"></p>
// </div>
// </div>
// </div>`
            : `<div class="m-bottom-half display-when-content-ready clear-both" id="calculadora-m2">
    <div class="row-fluid">
        <div class="contenedor">
            <h4><strong>Calculadora</strong></h4>
            <p>Ingresá el alto y el ancho de la superficie a cubrir. Recordá que 1 unidad de producto es 1 metro cuadrado.</p>
            <div class="conjunto">
                <label>Alto (m)</label>
                <input type="number" min="0" max="99" step=".01" name="alto" placeholder="Ej: 3.20" />
            </div>
            <div class="conjunto">
                <label>Ancho (m)</label>
                <input type="number" min="0" max="99" step=".01" name="ancho" placeholder="Ej: 2" />
            </div>  
            <a class="calcule" href="#">Calcular</a>
            <p class="resultado notranslate"></p>
        </div>
    </div>
</div>
`

    const calculator = document.createElement('div')
    calculator.innerHTML = calculatorDiv

    const quantityDiv = document.querySelector('.product-form__quantity')
    if (quantityDiv) {
        quantityDiv.prepend(calculator)
    }

    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('calcule')) {
            e.preventDefault();
            const alto = document.querySelector('input[name="alto"]').value.replace(',', '.');
            const ancho = document.querySelector('input[name="ancho"]').value;
            if (alto === "" || ancho === "" || alto === "0" || ancho === "0") {
                alert(portuguese ? 'Revise os campos para calcular' 
                // : isAbroad ? 'Please check the fields to calculate' 
                : 'Por favor revise los campos a calcular.');
                return false;
            }

            const m2 = (Math.ceil(ancho) * parseFloat(alto)).toFixed(2);
            const productPrice = parseFloat(document.querySelector('.price-item').textContent.trim().replace(/[^\d.,]/g, ''));
            const m2Value = (parseFloat(productPrice) * parseFloat(m2)).toFixed(2).toString().replace('.', ',');

            // console.log('m2', m2)
            // console.log('productPrice', productPrice)
            // console.log('m2Value', m2Value)

            const resultadoElement = document.querySelector('.resultado');
            resultadoElement.innerHTML = portuguese ? 'São necessários: <strong>' + m2 + ' metros quadrados</strong>.<br><br>O preço total é de <strong class="trans-money notranslate trans-money-done">R$' + m2Value + '</strong><br><br>Não realizamos instalação, mas temos instaladores para recomendar. <i>(Você deve discutir o valor com o instalador, que pode variar dependendo da região onde será realizado o trabalho).</i>'
                // : isAbroad ? "You need: <strong>" + m2 + " square meters</strong>.<br><br>The total price is <strong class='trans-money notranslate trans-money-done'>$" + m2Value + "</strong>.<br><br>We do not provide installation services, but we have installers to recommend. <i>(You should discuss the price with the installer, which may vary depending on the region where the work will be done).</i>"
                    : 'Son necesarios: <strong>' + m2 + ' metros cuadrados</strong>.<br><br>El precio en total es de <strong class="trans-money notranslate trans-money-done">$' + m2Value + '</strong><br><br>No realizamos colocación pero tenemos colocadores para recomendarte. <i>(El valor deberás conversarlo con el colocador y puede variar de acuerdo a la zona donde realizará el trabajo).</i>';

            document.querySelector('.quantity__input').value = Math.ceil(Number(m2));
        }
    });

    document.addEventListener('change', function (e) {
        if (e.target.closest('.desktop-variant')) {
            document.querySelector('.resultado').innerHTML = '';
        }
    });

    document.querySelector('.js-mobile-vars-selected-label')?.addEventListener('DOMSubtreeModified', function () {
        document.querySelector('.resultado').innerHTML = '';
    });

    if (document.querySelector('.calculadora-excluida')) {
        const calculadoraM2 = document.querySelector('#calculadora-m2');
        if (calculadoraM2) {
            calculadoraM2.style.display = 'none';
            calculadoraM2.remove();
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    translateWhenFromAbroad()
});
